// src/components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 Travel Sri Lanka. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
